import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';

const dummyStudies = [
  {
    id: '1',
    studyTitle: 'Efficacy of Paracetamol in Pain Management',
    publicationDate: '2024-06-20',
  },
  {
    id: '2',
    studyTitle: 'Safety Analysis of Paracetamol in Long-Term Use',
    publicationDate: '2023-12-01',
  },
];

const ClinicalStudies = () => {
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Clinical Studies</CardTitle>
        <div>
          {dummyStudies.map((study) => (
            <div key={study.id} className="mb-3">
              <h5 className="font-size-15">{study.studyTitle}</h5>
              <p className="text-muted">Publication Date: {study.publicationDate || 'N/A'}</p>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default ClinicalStudies;
